import { create } from 'zustand';

export type ProfileData = {
	id: string;
	firstName: string;
	lastName: string;
	supporterNumber: number;
	membership: string;
	ticketPoints: number;
	lang?: string;
	avatar: {
		url: string;
		mimeType: string;
		width: number;
		height: number;
	};
};

export type LocalizationDataType = {
	[index: string]: {
		[middleIndex: string]: {
			[innerIndex: string]: string;
		};
	};
};

export type SessionState = {
	localizationData: LocalizationDataType | null;
	profileData: ProfileData | null;
	displayLang: string;
	getDictionaryItem: (filterItem: string) => string;
	setLocalizationData: (data: LocalizationDataType | null) => void;
	setProfileData: (data: ProfileData | null) => void;
	setDisplayLang: (lang: string) => void;
};

export const useSessionStore = create<SessionState>((set, get) => ({
	localizationData: null,
	profileData: null,
	displayLang: 'en',
	getDictionaryItem: (filterItem: string) => {
		const { localizationData, displayLang } = get();
		if (!localizationData) return '';
		if (Object.keys(localizationData).length === 0) return '';
		for (const key in localizationData) {
			if (
				Object.prototype.hasOwnProperty.call(
					localizationData[key],
					filterItem
				)
			) {
				return localizationData[key][filterItem][displayLang] ?? '';
			}
		}
		return '';
	},
	setLocalizationData: (localizationData) => set({ localizationData }),
	setProfileData: (profileData) => set({ profileData }),
	setDisplayLang: (displayLang) => set({ displayLang }),
}));
